export enum SearchDateRange {
    All = 0,
    Today = 1,
    ThisWeek = 2,
    LastWeek = 3,
    ThisMonth = 4,
    LastMonth = 5,
    ThisQuarter = 6,
    LastQuarter = 7,
    ThisYear = 8,
    LastYear = 9,
    Custom,
    Last90Days,
    Last30Days,
    Unspecified = -1 //behaves like all
}
